import { WISHLIST_POLL_ROUTE_PREFIXES } from '../config/backgroundSyncConfig';

/** Wishlist heart lives in the global header on most shop routes. */
export const isWishlistPollRoute = (pathname: string): boolean => {
    if (!pathname) {
        return false;
    }
    const path = pathname.toLowerCase();
    if (path === '/login' || path === '/forgot-password') {
        return false;
    }
    return WISHLIST_POLL_ROUTE_PREFIXES.some((prefix) => {
        return path === prefix || path.indexOf(prefix + '/') === 0;
    });
};
